var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStarIconB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.71468 0.878116C7.80449 0.601723 8.19551 0.601722 8.28532 0.878115L9.95327 6.01155C9.99343 6.13516 10.1086 6.21885 10.2386 6.21885H15.6362C15.9268 6.21885 16.0477 6.59073 15.8125 6.76155L11.4458 9.93419C11.3406 10.0106 11.2966 10.146 11.3368 10.2696L13.0048 15.403C13.0946 15.6794 12.7782 15.9093 12.5431 15.7384L8.17634 12.5658C8.07119 12.4894 7.92881 12.4894 7.82366 12.5658L3.4569 15.7384C3.22179 15.9093 2.90544 15.6794 2.99525 15.403L4.6632 10.2696C4.70337 10.146 4.65937 10.0106 4.55422 9.93419L0.187461 6.76155C-0.0476527 6.59073 0.0731797 6.21885 0.363797 6.21885H5.76141C5.89138 6.21885 6.00657 6.13516 6.04673 6.01155L7.71468 0.878116Z",
    fill: "#757A88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIconB);
export default __webpack_public_path__ + "static/media/star_icon_b.f856424a9d5658dbe8e88601fe6e7985.svg";
export { ForwardRef as ReactComponent };